<div
	[attr.id]="descriptionId()"
	[class]="descriptionClass()"
	[innerHTML]="html() | descriptionHtml"
	stagesResizeImageMaps
	stagesReplaceBigTables
	stagesLazyReferenceResolver
	[html]="html()"
></div>
